import { Col, Form, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';
import {
  DirectSaleXFinancialFilterBy,
  DirectSaleXFinancialFilterDateBy,
  DirectSaleXFinancialReportType,
} from '@/core/domain/questReport/Reports/DirectSaleXFinancial/DirectSaleXFinancial.types';

const FieldFilterByFinancial: React.FC = () => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Col sm={24}>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const filterDateBy = getFieldValue('filterDateBy');
          const reportType = getFieldValue('reportType');

          return (
            <>
              {filterDateBy === DirectSaleXFinancialFilterDateBy.sale ||
                (reportType === DirectSaleXFinancialReportType.overview && (
                  <>
                    <Title level={5}>
                      {intl.formatMessage({
                        id: 'movementDirectSaleXFinancial.form.filterFinancialBy',
                      })}
                    </Title>

                    <Form.Item
                      name="filterBy"
                      initialValue={DirectSaleXFinancialFilterBy.emission}
                      noStyle
                    >
                      <Radio.Group
                        optionType="button"
                        buttonStyle="solid"
                        size="large"
                      >
                        <Radio value={DirectSaleXFinancialFilterBy.emission}>
                          {intl.formatMessage({
                            id: 'movementDirectSaleXFinancial.form.filterFinancialBy.emission',
                          })}
                        </Radio>

                        <Radio value={DirectSaleXFinancialFilterBy.dueDate}>
                          {intl.formatMessage({
                            id: 'movementDirectSaleXFinancial.form.filterFinancialBy.dueDate',
                          })}
                        </Radio>

                        <Radio value={DirectSaleXFinancialFilterBy.receipt}>
                          {intl.formatMessage({
                            id: 'movementDirectSaleXFinancial.form.filterFinancialBy.receipt',
                          })}
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </>
                ))}
            </>
          );
        }}
      </Form.Item>
    </Col>
  );
};

export default FieldFilterByFinancial;
